import {SystemStyleObject} from '@chakra-ui/react';

// Custom styles for the map component
export const mapStyles: Record<string, SystemStyleObject> = {
  mapContainer: {
    borderRadius: 'lg',
    overflow: 'hidden',
    boxShadow: 'base',
  },
  popupContainer: {
    padding: 3,
    borderRadius: 'md',
  },  popupTitle: {
    fontWeight: '700',
    fontSize: 'md',
    marginBottom: 2,
    color: '#0066cc',
  },
  popupImage: {
    borderRadius: 'md',
    marginBottom: 2,
  },
  popupDescription: {
    fontSize: 'sm',
    marginBottom: 2,
  },
  popupLink: {
    fontWeight: 'medium',
    fontSize: 'sm',
    color: 'blue.500',
    _hover: {
      textDecoration: 'underline',
    },
  },

  // Styles to make the map's attribution more readable
  attribution: {
    position: 'absolute',
    bottom: '2px',
    right: '2px',
    fontSize: '10px',
    backgroundColor: 'rgba(255,255,255,0.7)',
    padding: '0 2px',
    borderRadius: '2px',
  },
};

// Add custom styles for popups that override Leaflet's default styles
export const leafletPopupStyles = `
  .leaflet-popup-content-wrapper {
    border-radius: 8px;
    padding: 0;
    overflow: hidden;
  }
  
  .leaflet-popup-content {
    margin: 0;
    padding: 0;
    min-width: 240px;
    max-width: 300px;
  }
  
  .leaflet-popup-tip {
    background-color: white;
  }
  
  .leaflet-container a.leaflet-popup-close-button {
    top: 5px;
    right: 5px;
    z-index: 10;
  }

  .leaflet-container {
    font-family: inherit;
  }
  

  /* Improve markers for touch devices */
  .leaflet-marker-icon {
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.2));
  }
  
  /* Custom marker shadow effect for image-based markers */
  .location-marker-with-shadow {
    filter: drop-shadow(0 5px 5px rgba(0, 0, 0, 0.3));
    border-radius: 50%;
    background: white;
    transition: transform 0.2s;
  }

  /* Custom styling for the Walkabout logo pin marker */
  .walkabout-location-marker {
    filter: drop-shadow(0 3px 3px rgba(0, 0, 0, 0.25));
    transition: transform 0.2s ease;
  }
  
  .walkabout-location-marker:hover, 
  .walkabout-location-marker:active {
    transform: scale(1.1);
    filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.3));
  }
  
  .user-location-marker {
    border-radius: 50%;
    background: white;
    box-shadow: 0 0 0 2px white, 0 0 0 5px rgba(39, 106, 205, 0.3), 0 0 10px rgba(0, 0, 0, 0.2);
  }
`;

export default mapStyles;
